<div class="mall-container">
  <rask-selector
    label="Produktionsmallar"
    [viewFormatter]="valueFormatter"
    (change)="onProduktionsmallChanged($event)"
    [formatter]="selectionFormatter"
    [values]="produktionsmallar"
    [disabled]="!canEdit()"
    [showHeader]="true">
    <ng-container header>
      <div class="custom-highlight">
        <a [routerLink]="['/minaproduktionsmallar']" target="_blank">Mina produktionsmallar <i class="far fa-external-link" aria-hidden="true"></i></a>
      </div>
    </ng-container>
  </rask-selector>
</div>
@for (hsGrupp of handelssortimentsgrupper; track hsGrupp) {
  <div>
    <rask-arbetsorder-handelssortimentsval-rad
      [handelssortimentsgrupp]="hsGrupp"
      [arbetsorderWrapper]="arbetsorderWrapper"
      [produktionsmall]="selectedProduktionsmall"
      (onSelectionEvent)="onSelectionEvent($event)">
    </rask-arbetsorder-handelssortimentsval-rad>
  </div>
}
<div>
  <div class="row">
    <span class="col-10">
      Summa
    </span>
    <span class="col-2 value" aid="produktval-sum-value">
      {{totalsummaAsText}}
    </span>
  </div>
</div>